import { render, staticRenderFns } from "./TdtMiniMap.vue?vue&type=template&id=4c935670&scoped=true"
import script from "./TdtMiniMap.vue?vue&type=script&lang=js"
export * from "./TdtMiniMap.vue?vue&type=script&lang=js"
import style0 from "./TdtMiniMap.vue?vue&type=style&index=0&id=4c935670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c935670",
  null
  
)

export default component.exports